import Icon from "~/components/shared/Icon";
import { BuildView } from "~/components/build/Show/lib/types/BuildView";

interface Props {
  number: number;
  path: string;
  branchName?: string;
  currentView?: BuildView;

  nextBranchBuild?: {
    url: string;
    number: number;
  };
  prevBranchBuild?: {
    url: string;
    number: number;
  };
}

function urlForView(buildUrl: string, view?: BuildView) {
  switch (view) {
    case BuildView.Canvas:
      return `${buildUrl}/canvas`;
    case BuildView.Waterfall:
      return `${buildUrl}/waterfall`;
    default:
      return `${buildUrl}`;
  }
}

// @deprecated (New version is at app/javascript/components/build/Header/BuildNumber.tsx)
// Remove once new build UI is rolled out.
export default function BuildNavigator({
  currentView,
  number,
  path,
  branchName,
  prevBranchBuild,
  nextBranchBuild,
}: Props) {
  return (
    <div className="flex items-center gap-2">
      {prevBranchBuild && (
        <a
          href={urlForView(prevBranchBuild.url, currentView)}
          title={`Previous build (#${prevBranchBuild.number}) on ${branchName}`}
          className="color-inherit hover-color-inherit flex items-center"
        >
          <Icon icon="heroicons/outline/chevron-left" style={{ height: 14, width: 14 }} />
        </a>
      )}

      {path === window.location.pathname ? (
        <span className="flex items-center">#{number}</span>
      ) : (
        <a className="color-inherit hover-color-inherit flex items-center" href={path}>
          #{number}
        </a>
      )}

      {nextBranchBuild && (
        <a
          href={urlForView(nextBranchBuild.url, currentView)}
          title={`Next build (#${nextBranchBuild.number}) on ${branchName}`}
          className="color-inherit hover-color-inherit flex items-center"
        >
          <Icon icon="heroicons/outline/chevron-right" className="h-[14px] w-[14px]" />
        </a>
      )}
    </div>
  );
}
